module.exports = __webpack_public_path__ + "static/loading2-6030c69f0492ce82f4c7550f45e77694.gif";